<template>
  <v-dialog
    v-model="dialog"
    max-width="1000px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="info"
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-information-outline
            </v-icon>
          </v-btn>
        </template>
        <span>View Claimed History</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="View Claimed Requests"
      :text="(entitlement.assignable.person ? entitlement.assignable.person.name : entitlement.assignable.name) + ' (' + entitlement.claim_type.name + ')'"
      class="mb-0"
      max-height="750px"
    >
      <v-container>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="claimRequestEntries"
          class="overflow"
        >
          <template v-slot:item.type="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  color="grey"
                  class="mr-1"
                  v-on="on"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              Created at {{ $moment(item.created_at).format('YYYY-MM-DD hh:mmA') }}
            </v-tooltip>
            <span>{{ item.claim_type.name }}</span>
          </template>

          <template v-slot:item.cycle="{ item }">
            <span>{{ item.claim_request.claim_cycle.start_date }} - {{ item.claim_request.claim_cycle.end_date }}</span>
          </template>

          <template v-slot:item.amount="{ item }">
            {{ thousandSeparator((item.total_amount / 100).toFixed(2)) }}
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  color="hrissecondary"
                  v-on="on"
                >
                  mdi-information-outline
                </v-icon>
              </template>
              RM{{ thousandSeparator((item.amount / 100).toFixed(2)) }} x {{ item.quantity }} unit
            </v-tooltip>
          </template>

          <template v-slot:item.action="{ item }">
            <employee-claims-approvals-entries-dialog-view 
              :claim-request-entry="item" 
            />
          </template>
        </v-data-table>
      </v-container>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      EmployeeClaimsApprovalsEntriesDialogView: () => import('@/components/employee/claims/approvals/entries/DialogView'),
    },
    props: {
      entitlement: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        headers: [
          {
            text: 'Type',
            align: 'left',
            sortable: false,
            value: 'type',
          },
          {
            text: 'Claim Cycle',
            align: 'left',
            sortable: false,
            value: 'cycle',
          },
          {
            text: 'Reference No.',
            align: 'left',
            sortable: false,
            value: 'claim_request.reference_number',
          },
          {
            text: 'Amount (RM)',
            align: 'right',
            sortable: false,
            value: 'amount',
          },
          {
            text: '',
            align: 'center',
            sortable: false,
            value: 'action',
          },
        ],
        claimRequestEntries: [],
      }
    },

    watch: {
      dialog: function (value) {
        this.loading = true
        if (value) {
          this.claimRequestEntries = _.orderBy(
            this.entitlement.entries,
            [entry => entry.claim_request.claim_cycle.start_date || ''],
            ['desc']
          )

          this.loading = false
        }
      },
    },

    methods: {
      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },
    },
  }
</script>

<style lang="css" scoped>
  .overflow {
    max-height:600px;
    overflow: auto;
  }
</style>
